import React, { useState, useEffect, useCallback } from 'react'
import { services } from '../../services'
import { ReactComponent as RefreshIcon } from '../../assets/icons/map/IconSwitch.svg'
import { Notification, GoogleMapControls,GoogleMapBoundary , MiniMap, Tooltip, GoogleMap } from '../../components'
import LoadingInvAsset from './LoadingAsset'
import CustomModal from '../../components/CustomModal'
import ModalAssetBranch from '../../components/MapAssetLoader/ModalAssetBranch'
import InfoClick from './InfoClick'

const MIN_ZOOM = 7
const MAX_ZOOM = 20
const ZOOM_LEVEL_ASSET_LOAD = 18
const DEFAULT_CENTER_LEVEL = { lat: 43.0181804067, lng: -78.9163065183 }
const ZoomPlus = require('../../assets/icons/map/Plus.svg')
const ZoomMinus = require('../../assets/icons/map/Less.svg')
const { api } = services

const IS_OK = status => status === 'OK'

export const SearchingNotification = ({ location, submitting }) => {
  return submitting && (
    <Notification Icon={RefreshIcon} className="notification-info notification-invmap">
      Searching for {location || 'address'}
    </Notification>
  )
}

export const NothingFoundNotification = () => {
  return (
    <Notification className="notification-warning notification-invmap">
      Unable to find this address within the service area.
      Please refine your search criteria
    </Notification>
  )
}

export const LoadingAssetsNotification = () => {
  return (
    <Notification Icon={RefreshIcon} className="notification-info notification-invmap">
      Loading Assets
    </Notification>
  )
}

const InventoryMapContainer = (props) => {

  const [mapAPI, setMapAPI] = useState()
  const [assets, setAssets] = useState([])
  const [loadingAssets, setLoadingAssets] = useState(false)
  const [centerLevel] = useState(DEFAULT_CENTER_LEVEL)
  const [submitting, setSubmitting] = useState(false)
  const [geocoderAPI, setGeocoderAPI] = useState()
  const [autocompleteAPI, setAutocompleteAPI] = useState()
  const [location, setLocation] = useState('')
  const [polygon1, setPolygon1] = useState()
  const [polygon2, setPolygon2] = useState()
  const [polygon3, setPolygon3] = useState()
  const [nothingFoundMessage, setNothingFoundMessage] = useState(false)
  const [nestModal, setNestModal] = useState(false)
  const [asset, setAsset] = useState()
  const [closeIconStatus, setCloseIconStatus] = useState(false)
  const [isErrorModalStyle, setIsErrorModalStyle] = useState(false)

  const mapOptions = {
    zoom: 7,
    center: centerLevel,
    disableDefaultUI: true,
    tilt: 0,
    scrollwheel: false,
    gestureHandling: "greedy",
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  }

  const onGoogleMapMount = (mapAPI, autocompleteAPI, geocoderAPI) => {
    setMapAPI(mapAPI)
    setAutocompleteAPI(autocompleteAPI)
    setGeocoderAPI(geocoderAPI)
  }

  const fetchAssets = useCallback(() => {
    api.getInventoryAssets(props.refNumber).then((response) => {
      if(response.data.InventoryMapData.length > 0){
        setAssets(response.data.InventoryMapData)
        let invLat = response.data.InventoryMapData[0].Latitude
        let invLng = response.data.InventoryMapData[0].Longitude
        let invPos = {lat : Number(invLat), lng: Number(invLng)}
        mapAPI && mapAPI.setOptions({ zoom: ZOOM_LEVEL_ASSET_LOAD, center: invPos })
      }
      else{
        mapAPI && mapAPI.setOptions({ zoom: ZOOM_LEVEL_ASSET_LOAD, center: centerLevel })
      }
    }, (error) => {
    })
  }, [mapAPI, props.refNumber,centerLevel])


  useEffect(() => {
    async function initFetch() {
      mapAPI && mapAPI.setZoom(ZOOM_LEVEL_ASSET_LOAD)
      fetchAssets()
    }
    initFetch()
    setLoadingAssets(true)
    const timer1000 = setTimeout(() => {
      setLoadingAssets(false)
    }, 1000)
    return () => {
    
      window.clearTimeout(timer1000)
    }
    // eslint-disable-next-line
  }, [mapAPI])

  LoadingInvAsset(mapAPI, assets, InfoClick)

  const goToZoomIn = () => {
    if (mapAPI.getZoom() < MAX_ZOOM) {
      mapAPI.setOptions({ zoom: mapAPI.getZoom() + 1 })
    }
  }

  const goToZoomOut = () => {
    if (mapAPI.getZoom() > MIN_ZOOM) {
      mapAPI.setOptions({ zoom: mapAPI.getZoom() - 1 })
    }

  }

  const modalToggle = () => {
    setNestModal(false)
  }

  const noCloseIcon = (closeIconButton) => {
    setCloseIconStatus(closeIconButton)
  }

  const onLocationSubmit = ({ location }) => {
    if (location && location.length >= 1) {
      setSubmitting(true)
      getPlacePredictions(location)
    }
  }

  const options = {
    types: ['geocode'],
    componentRestrictions: {
      country: 'us',
    },
  }

  const getPlacePredictions = async (input) => {
    autocompleteAPI.getPlacePredictions(
      {
        input,
        options,
      },
      displaySuggestions
    )
  }

  const displaySuggestions = async (predictions, status) => {
    if (IS_OK(status)) {
      const [address] = (predictions || []).map(prediction => prediction.description)
      geocodePrediction(address)
    } else {
      await sleep(1000)
      setSubmitting(false)
      showNotFoundMessage()
    }
  }

  const showNotFoundMessage = async () => {
    setNothingFoundMessage(true)
    await sleep(5000)
    setNothingFoundMessage(false)
  }

  const sleep = async (ms) => {
    return new Promise((resolve, reject) => {
      if (isNaN(ms)) {
        reject(new Error('sleep requires a valid number'))
      } else {
        window.setTimeout(resolve, ms)
      }
    })
  }

  const geocodePrediction = address => geocoderAPI.geocode({
    address,
    componentRestrictions: {
      country: 'us',
    },
  },
  displayLocation
  )

  const displayLocation = async (result, status) => {
    await sleep(1000)
    setSubmitting(false)
    if (IS_OK(status)) {
      const [{ geometry: { location } }] = result
      const isInNY = isInNYBoundary(location)
      if (isInNY) {
        await sleep(250)
        mapAPI.panTo(location)
        if (mapAPI.getZoom() !== ZOOM_LEVEL_ASSET_LOAD) {
          mapAPI.setZoom(ZOOM_LEVEL_ASSET_LOAD)
        }
      } else {
        showNotFoundMessage()
      }
    } else {
      showNotFoundMessage()
    }
  }

  const isInNYBoundary = (location) => {
    const resultBound1 = window.google.maps.geometry.poly.containsLocation(
      location,
      polygon1
    )
    const resultBound2 = window.google.maps.geometry.poly.containsLocation(
      location,
      polygon2
    )
    const resultBound3 = window.google.maps.geometry.poly.containsLocation(
      location,
      polygon3
    )
    return (resultBound1 || resultBound2 || resultBound3)
  }

  const onLocationChange = async ({ location }) => {
    setLocation(location)
    await sleep(1000)
    
  }

  return (
    <>
      <GoogleMapControls {...{ location, onLocationSubmit, onLocationChange }} />
      <GoogleMap onMount={onGoogleMapMount} options={mapOptions} />
      <SearchingNotification {...{ location, submitting }} />
      {mapAPI && <GoogleMapBoundary
        map={mapAPI} nestModal={nestModal}
        setAsset={setAsset} setNestModal={setNestModal}
        setPolygon1={setPolygon1} setPolygon2={setPolygon2} setPolygon3={setPolygon3}
      />}
      <div className="inventorymap-controller-container">
        <Tooltip aria-label={`Map Zoom Out`} data-test="map-zoomout-text" tooltipcontent={<span>Map Zoom In</span>}>
          <img className="icon-maps" data-test="zoomPlus" src={ZoomPlus} onClick={goToZoomIn} alt="zoom in" />
        </Tooltip>

        <div className="icon-location-zoomout" data-test="map-zoomout">
          <Tooltip aria-label={`Map Zoom Out`} data-test="map-zoomout-text" tooltipcontent={<span>Map Zoom Out</span>}>
            <img className="icon-maps" data-test="zoomMinus" src={ZoomMinus} onClick={goToZoomOut} alt="zoom out" />
          </Tooltip>
        </div>
      </div>
      <div  className='invminimap'>
        {mapAPI && <MiniMap map={mapAPI} />}
      </div>
      {loadingAssets && <LoadingAssetsNotification />}
      {!submitting && nothingFoundMessage && <NothingFoundNotification />}
      {
        nestModal
          ? <CustomModal
            modalContent={
              <ModalAssetBranch
                asset={asset}
                setNestModal={setNestModal}
                onclickOpen={modalToggle}
                noCloseIcon={noCloseIcon}
                isErrorModalStyle={isErrorModalStyle}
                setIsErrorModalStyle={setIsErrorModalStyle}
              />
            }
            onclickOpen={modalToggle}
            isShowContent={true}
            hideCloseIcon={closeIconStatus}
            noCloseIcon={noCloseIcon}
            isErrorModalStyle={isErrorModalStyle}
            setIsErrorModalStyle={setIsErrorModalStyle}
          />
          : null
      }
    </>
  )
}

export default InventoryMapContainer